import { Suspense } from "react";
import Routes from "./routes";
import Loader from "component/Loader";
import MaintenancePage from "MaintenancePage";

const App = () => {
  const isDowntime = () => {
    try {
      const downtimeValue = process.env.REACT_APP_MAINTENANCE_MODE;
      return downtimeValue === "true" || downtimeValue === true;
    } catch (error) {
      console.error("Error parsing maintenance mode:", error);
      return false;
    }
  };

  return (
    <Suspense fallback={<Loader />}>
      {isDowntime() ? <MaintenancePage /> : <Routes />}
    </Suspense>
  );
};

export default App;
